import { CustomerLogo, MainLogo } from 'components/_common/Icons';
import LeftChevronSvg from 'components/_common/Icons/SVGIcons/LeftChevronSvg';
import LazyImage from 'components/_common/LazyImage';
import { t } from 'i18next';
import { useCallback } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { loginRoutes } from 'routes/admin/AdminRoutes';
import { customerMainRoutes, getCustomerContentPageRoute } from 'routes/customer/CustomerRoutes';
import PublicRoute from 'routes/PublicRoute';

// import 'LoginLeft' from from 'assets/images/profile.svg';
export default function LoginLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  // Real href kept for right-click/new-tab, but a plain click goes back to wherever
  // the user actually came from (not always /login - e.g. the mobile hamburger drawer
  // links straight to these signup pages).
  const handleBackClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      navigate(-1);
    },
    [navigate]
  );

  return (
    <PublicRoute>
      <div className="container-fluid login-layout-wrapper">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-6 col-md-4 login-main-screen p-0 auth-layout">
            <div className="login-main-left">
              <div className="text-start mb-1 logo-img">
                <Link to={customerMainRoutes.customerHome.path}>
                  <LazyImage src={MainLogo} alt="Logo" className="login-layout-logo" />
                </Link>
              </div>
              {/* <div className="content-text"> */}
              <h6>{t('login_instruction_1')}</h6>

              <h1> {t('login_instruction_2')}</h1>

              <h4> {t('login_instruction_3')}</h4>
              {(location?.pathname === loginRoutes.login.path ||
                location?.pathname === loginRoutes.login.path + '/' ||
                location?.pathname === loginRoutes.home.path ||
                location?.pathname === loginRoutes.customerSignup.path ||
                location?.pathname === loginRoutes.customerSignup.path + '/') && (
                <div className="d-flex mt-3 login-bth">
                  <Link
                    className="btn login-bth"
                    style={{ background: '#f54900 !important' }}
                    to={loginRoutes.signup.path}
                  >
                    {t('ffl_sign_up')}
                  </Link>
                </div>
              )}
              {(location?.pathname === loginRoutes.signup.path ||
                location?.pathname === loginRoutes.signup.path + '/') && (
                <div className="d-flex mt-3 login-bth">
                  <Link
                    className="btn login-bth"
                    style={{ background: '#f54900 !important' }}
                    to={loginRoutes.customerSignup.path}
                  >
                    {t('customer_sign_up')}
                  </Link>
                </div>
              )}
            </div>
            {/* </div> */}
            <div className="login-main-right position-relative">
              {(location?.pathname === loginRoutes.signup.path ||
                location?.pathname === loginRoutes.signup.path + '/' ||
                location?.pathname === loginRoutes.customerSignup.path ||
                location?.pathname === loginRoutes.customerSignup.path + '/') && (
                <Link
                  to={loginRoutes.login.path}
                  onClick={handleBackClick}
                  className="icon-circle-back d-flex align-items-center justify-content-center position-absolute"
                  style={{ top: '-55px', left: '0', zIndex: 10 }}
                >
                  <LeftChevronSvg />
                </Link>
              )}
              <Outlet />
            </div>
          </div>
          <div className="footer d-flex flex-column flex-md-row justify-content-between align-items-center py-3 py-md-0 gap-3 gap-md-0 w-100">
            <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center py-3 py-md-0 gap-3 gap-md-0">
              <a
                href={customerMainRoutes.customerHome.path}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center gap-2"
              >
                <span>
                  © {new Date().getFullYear()} {t('mylocal_gun_shop_brand')}
                </span>
                <img src={CustomerLogo} alt="Logo" className="footer-brand-logo" />
              </a>
              <div className="footer-links d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 gap-md-4">
                <a
                  href={getCustomerContentPageRoute('terms_and_conditions')}
                  className="link-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and Conditions
                </a>
                <a
                  href={getCustomerContentPageRoute('privacy_policy')}
                  className="link-underline"
                  target="_blank" // optional: opens in a new tab
                  rel="noopener noreferrer" // recommended for security when using target="_blank"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicRoute>
  );
}
